const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

let parallaxItems = [];
let ticking = false;

function updateParallax() {
  ticking = false;

  if (motionQuery.matches) return;

  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const viewportCenter = viewportHeight / 2;

  for (const item of parallaxItems) {
    const rect = item.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > viewportHeight) continue;

    const speed = Number.parseFloat(item.dataset.backgroundParallaxSpeed || '0.28');
    const maxShift = Math.min(120, rect.height * 0.22);
    const extra =
      Number.parseFloat(getComputedStyle(item).getPropertyValue('--background-parallax-extra')) || 240;
    const maxTravel = extra / 2;
    const distanceFromCenter = rect.top + rect.height / 2 - viewportCenter;
    const travelRange = viewportCenter + rect.height / 2;
    const progress = Math.max(-1, Math.min(1, distanceFromCenter / travelRange));
    const rawShift = -progress * maxShift * speed * 5;
    const shift = Math.round(Math.max(-maxTravel, Math.min(maxTravel, rawShift)));

    item.style.setProperty('--background-parallax-y', `${shift}px`);
  }
}

function requestParallaxUpdate() {
  if (ticking) return;

  ticking = true;
  window.requestAnimationFrame(updateParallax);
}

function initParallax() {
  parallaxItems = Array.from(document.querySelectorAll('[data-background-parallax]'));

  if (motionQuery.matches) {
    for (const item of parallaxItems) {
      item.style.removeProperty('--background-parallax-y');
    }
    return;
  }

  requestParallaxUpdate();
}

window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
window.addEventListener('resize', requestParallaxUpdate);
document.addEventListener('shopify:section:load', initParallax);
document.addEventListener('DOMContentLoaded', initParallax);
motionQuery.addEventListener?.('change', initParallax);

initParallax();

